<template>
  <div class="cart-wrap" v-if="item">
    <div v-if="debug" style="position:absolute; margin-top: -8rem;">
      item price {{ item.value }} mod price {{ item_modifiers_price(item)}} qty   {{item.quantity}}
    </div>

    <a href="#" class="cart-trash" @click="removeItemFromCart(item)">
      <svg class="trash" fill="none">
        <use xlink:href="#trash" />
      </svg>
    </a>
    <div class="middle-detail">
      <h5>{{ _T_DB(item, 'name') }}</h5>
      <Modifiers
        v-if="item.modifiers"
        :modifiers="item.modifiers"
        :item="item"
      ></Modifiers>
      <!-- <a
        data-toggle="modal"
        data-target="#customizedModal"
        href="#"
        class="customized-cls"
        @click="showModal()"
      >
        <img src="/images/svg/global/edit.svg" class="img-fluid" alt="" />
        <h6>{{ _T('Customize') }}</h6>
      </a> -->
    </div>
    <QtyBox
      :qty="item.quantity || 1"
      :index="item.index"
      :isCart="true"
    ></QtyBox>
    <div class="price-right">
      <h5>
        {{ currency }}
        {{
          Num.price((item.value + item_modifiers_price(item)) * item.quantity)
        }}
      </h5>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QtyBox from '../../Blocks/Cart/QtyBox'
import Modifiers from './Modifiers'

export default {
  name: 'RegularItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    QtyBox,
    Modifiers,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'hasModifiers',
      'item_modifiers_price',
      'brandStoreRoute',
    ]),
  },
  methods: {
    ...mapActions(['removeItemFromCart']),
    showModal() {
      this.$router.push({
        name: this.brandStoreRoute('store_page'),
        params: {
          brand_id: this.item.brand_id,
          store_id: this.item.store_id,
        },
      })
      this.$store.commit('OPEN_CART_SIDEBAR')
      document.body.classList.remove('body-overlay')
      // this.$store.commit('SELECT_ITEM', this.item)
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', this.isModalVisible)
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .cart-wrap {
    .middle-detail {
      padding-right: 12px;
      padding-left: unset;
    }
    .price-right {
      margin-left: unset;
    }
  }
}
.cart-wrap {
  padding: 1.875rem 0;
  display: flex;
  align-items: center;
  border-bottom: $px1 solid $light-border;
  .cart-trash {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.25rem;
    background-color: rgba(var(--color-primary-source), 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.25rem;
    .trash {
      width: $px22;
      height: $px22;
    }
  }
  .middle-detail {
    h5 {
      text-transform: capitalize;
      font-weight: 600;
      max-width: $px200;
    }
    .customized-cls {
      display: flex;
      align-items: center;
      h6 {
        line-height: 1.063rem;
        margin-bottom: 0;
        margin-left: 0.313rem;
        text-transform: capitalize;
        color: $warning-color;
      }
    }
  }
  .price-right {
    margin-left: $px20;
    h5 {
      text-transform: uppercase;
      margin-bottom: 0;
      font-weight: 600;
    }
  }
}
</style>
